import FlashcardComponent from '@views/quizzes/flashcards/show';
import FlashcardV2Component from '@views/quizzes/flashcards-v2/show';
import ProgressFlashcardComponent from '@views/progress/questions/show';

export default [
  {
    path: '/quizzes',
    name: 'quizzes#index',
    component: () => import('@views/quizzes/index'),
    meta: {
      header: true,
    },
  },
  {
    path: '/quiz_categories',
    name: 'quiz_categories#index',
    component: () => import('@views/quizzes/quiz_categories/index.vue'),
    meta: {
      header: true,
    },
  },
  {
    path: '/quizzes/create/show',
    name: 'quizzes#create',
    component: () => import('@views/quizzes/create'),
    meta: {
      header: true,
      resourceOptional: true,
    },
  },
  {
    path: '/quizzes/:categoryId/flashcards/:flashcardId?',
    name: 'quizzes#flashcard',
    component: FlashcardComponent,
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
  {
    path: '/quizzes/:categoryId/flashcards-v2/:flashcardId?',
    name: 'quizzes#flashcard-v2',
    component: FlashcardV2Component,
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
  {
    path: '/quizzes/:categoryId/results',
    name: 'quizzes#results',
    component: () => import('@views/quizzes/results'),
    meta: {
      header: true,
    },
  },
  {
    path: '/quizzes/:categoryId/results/:flashcardId',
    component: ProgressFlashcardComponent,
    name: 'quizzes#results#question',
    meta: {
      header: true,
      masteryFooter: true,
    },
  },
];
